import type {EditMaterialDescriptionFormPayload} from "./edit-material-description.schema";

import type {Language} from "@project/sdk/engineering";
import {editMaterialDescription} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {materialKeys, materialMutationKeys} from "../../../../../material-keys";

export function editMaterialDescriptionMutationOptions(id: string, language: Language) {
  return mutationOptions({
    mutationKey: materialMutationKeys.editMaterialDescription,
    mutationFn: (payload: EditMaterialDescriptionFormPayload) =>
      editMaterialDescription(id, language, payload),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: materialKeys.detail(id)}),
        client.invalidateQueries({queryKey: materialKeys.lists()}),
      ]);
    },
  });
}
